export const STRINGS = {
  en: {
    "nav.listings": "Listings",
    "nav.creditRepair": "Credit Repair",
    "nav.downPayment": "Down Payment",
    "nav.team": "Our Team",
    "nav.schedule": "Schedule Appointment",

    "hero.eyebrow": "The Valdivieso Group · DV Luxury Realty",
    "hero.line1": "The Art of",
    "hero.line2a": "Finding",
    "hero.line2b": "Home",
    "hero.line3": "in Las Vegas.",
    "hero.sub": "Every listing, clear at a glance — and a team that walks you from first tour to final signature, with credit repair and down payment assistance along the way.",
    "hero.browse": "Browse Listings",
    "hero.qualified": "Get Qualified to Buy",
    "hero.statCareer": "Career Sales",
    "hero.statYear": "Sold Last 12 Mo.",
    "hero.statAvg": "Average Price",
    "hero.nowShowing": "Now Showing",
    "hero.priceCut": "Price Cut",

    "card.forSale": "For Sale",
    "card.pending": "Pending",
    "card.sold": "Sold",
    "card.view": "View Residence",
    "card.tour": "Schedule Tour",
    "oh.label": "Open House",
    "dt.tour3d": "View 3D Tour",
    "dt.walkthrough": "Video Walkthrough",

    "stats.career": "Career Sales",
    "stats.year": "Sold Last 12 Months",
    "stats.avg": "Average Sale Price",
    "stats.bilingual": "Bilingual Team",

    "cr.eyebrow": "Buyer Readiness",
    "cr.h2a": "Credit, Repaired.",
    "cr.h2b": "Keys, Delivered.",
    "cr.body": "A low score is a detour, not a dead end. Our credit restoration roadmap has moved hundreds of Las Vegas buyers from declined to pre-approved.",
    "cr.s1t": "Free Credit Analysis",
    "cr.s1d": "We pull your full picture together and identify exactly what is holding your score back.",
    "cr.s2t": "Dispute & Rebuild Plan",
    "cr.s2d": "A written plan: what to dispute, what to pay down, and which tradelines to build.",
    "cr.s3t": "Score Watch to 620+",
    "cr.s3d": "We track progress with you month by month until you cross lender thresholds.",
    "cr.s4t": "Lender Handoff",
    "cr.s4d": "Warm introduction to lenders we trust, with your file already prepared.",
    "cr.cta": "Start My Credit Plan",
    "cr.target": "Target Score",

    "dp.eyebrow": "Nevada Programs",
    "dp.h2": "The down payment is not the wall you think it is.",
    "dp.body": "Most of our buyers qualify for at least one assistance program. We check every option before you spend a dollar of your own savings.",
    "dp.p1d": "Statewide Nevada program covering down payment and closing costs for qualified buyers.",
    "dp.p2d": "Assistance for first-time buyers in qualifying Nevada counties, paired with competitive rates.",
    "dp.p3d": "For every dollar you bring, matching grant funds multiply your down payment power.",
    "dp.cta": "Check My Eligibility",
    "dp.note": "Program terms change — we verify current eligibility at your appointment.",

    "rv.eyebrow": "Client Stories",
    "rv.heading": "786 sales. Here is what a few felt like.",

    "tm.eyebrow": "The Group",
    "tm.h2": "The names to know in Las Vegas real estate.",
    "tm.onyRole": "Principal Agent · DV Luxury Realty",
    "tm.aceRole": "Real Estate · Insurance · DV Luxury Realty",
    "tm.sales": "786 career sales",
    "tm.naykyRole": "Real Estate Agent · DV Luxury Realty",

    "cta.eyebrow": "Begin Here",
    "cta.h2a": "The keys are closer",
    "cta.h2b": "than you think.",
    "cta.body": "One appointment. We review your credit, your programs, and your listings — and leave you with a written plan to buy.",
    "cta.button": "Schedule an Appointment",

    "ft.tagline": "Las Vegas homes, listed clearly and shown honestly — with credit repair and down payment assistance to get you to the keys.",
    "ft.contact": "Contact",
    "ft.explore": "Explore",
    "ft.currentListings": "Current Listings",
    "ft.recentlySold": "Recently Sold",
    "ft.agentPortal": "Agent Portal",
    "ft.partners": "Our Trusted Partners",

    "home.nowShowing": "Now Showing",
    "home.currentListings": "Current Listings",
    "home.viewAll": "View the Full Collection",
    "home.recentlySold": "Recently Sold by The Valdivieso Group",

    "ls.eyebrow": "The Collection",
    "ls.h1": "Listings, without the noise.",
    "ls.sub": "Every home The Valdivieso Group is showing or has recently closed — clear prices, real photos, one click to a tour.",
    "ls.all": "All",
    "ls.forSale": "For Sale",
    "ls.sold": "Sold",
    "ls.anyBeds": "Any Beds",
    "ls.bedsSuffix": "+ Beds",
    "ls.anyPrice": "Any Price",
    "ls.under400": "Under $400K",
    "ls.searchPh": "Search address or ZIP…",
    "ls.residences": "Residences",
    "ls.residence": "Residence",
    "ls.loading": "Loading…",
    "ls.emptyTitle": "No residences match.",
    "ls.emptyBody": "Loosen a filter — or call",

    "dt.back": "All Listings",
    "dt.about": "About This Residence",
    "dt.listedBy": "Listed by The Valdivieso Group · DV Luxury Realty · Lic. #S.0200120",
    "dt.perSqft": "/ sq ft",
    "dt.beds": "Beds",
    "dt.baths": "Baths",
    "dt.sqft": "Sq Ft",
    "dt.schedule": "Schedule an Appointment",
    "dt.ask": "Ask us about credit repair and Nevada down payment assistance for this home.",
    "dt.agent": "Listing Agent",
    "dt.notFound": "This residence has moved on.",
    "dt.backTo": "Back to the Collection",

    "bk.eyebrow": "Private Appointment",
    "bk.title": "Schedule with The Valdivieso Group",
    "bk.namePh": "Full Name",
    "bk.phonePh": "Phone",
    "bk.emailPh": "Email (optional)",
    "bk.tour": "Property Tour",
    "bk.qualification": "Get Qualified to Buy",
    "bk.credit_repair": "Credit Repair Plan",
    "bk.down_payment": "Down Payment Assistance",
    "bk.notesPh": "Anything we should know? (optional)",
    "bk.submit": "Request Appointment",
    "bk.sending": "Sending…",
    "bk.prefer": "Prefer to talk? Call",
    "bk.success": "Appointment request received — we will confirm with you shortly.",
    "bk.error": "Could not send your request. Please call 702-241-4761.",

    marquee: [
      "Las Vegas, Nevada",
      "786 Homes Sold",
      "Credit Repair Specialists",
      "Down Payment Assistance",
      "DV Luxury Realty",
      "Se Habla Español",
    ],
  },
  es: {
    "nav.listings": "Propiedades",
    "nav.creditRepair": "Crédito",
    "nav.downPayment": "Pago Inicial",
    "nav.team": "Equipo",
    "nav.schedule": "Agendar Cita",

    "hero.eyebrow": "The Valdivieso Group · DV Luxury Realty",
    "hero.line1": "El Arte de",
    "hero.line2a": "Encontrar",
    "hero.line2b": "Hogar",
    "hero.line3": "en Las Vegas.",
    "hero.sub": "Cada propiedad, clara a simple vista — y un equipo que te acompaña del primer recorrido a la firma final, con reparación de crédito y ayuda para el pago inicial.",
    "hero.browse": "Ver Propiedades",
    "hero.qualified": "Califica para Comprar",
    "hero.statCareer": "Ventas Totales",
    "hero.statYear": "Vendidas (12 Meses)",
    "hero.statAvg": "Precio Promedio",
    "hero.nowShowing": "En Exhibición",
    "hero.priceCut": "Precio Reducido",

    "card.forSale": "En Venta",
    "card.pending": "Pendiente",
    "card.sold": "Vendida",
    "card.view": "Ver Propiedad",
    "card.tour": "Agendar Visita",
    "oh.label": "Casa Abierta",
    "dt.tour3d": "Recorrido Virtual 3D",
    "dt.walkthrough": "Video del Recorrido",

    "stats.career": "Ventas Totales",
    "stats.year": "Vendidas en 12 Meses",
    "stats.avg": "Precio Promedio",
    "stats.bilingual": "Equipo Bilingüe",

    "cr.eyebrow": "Preparación del Comprador",
    "cr.h2a": "Crédito, Reparado.",
    "cr.h2b": "Llaves, Entregadas.",
    "cr.body": "Un puntaje bajo es un desvío, no un callejón sin salida. Nuestro plan de restauración de crédito ha llevado a cientos de compradores de Las Vegas del rechazo a la pre-aprobación.",
    "cr.s1t": "Análisis de Crédito Gratis",
    "cr.s1d": "Reunimos tu panorama completo e identificamos exactamente qué está frenando tu puntaje.",
    "cr.s2t": "Plan de Disputa y Reconstrucción",
    "cr.s2d": "Un plan por escrito: qué disputar, qué pagar primero y qué líneas de crédito construir.",
    "cr.s3t": "Vigilancia del Puntaje a 620+",
    "cr.s3d": "Seguimos tu progreso contigo mes a mes hasta cruzar los umbrales de los prestamistas.",
    "cr.s4t": "Conexión con Prestamistas",
    "cr.s4d": "Presentación directa con prestamistas de confianza, con tu expediente ya preparado.",
    "cr.cta": "Empezar Mi Plan de Crédito",
    "cr.target": "Puntaje Meta",

    "dp.eyebrow": "Programas de Nevada",
    "dp.h2": "El pago inicial no es la barrera que crees.",
    "dp.body": "La mayoría de nuestros compradores califican para al menos un programa de ayuda. Revisamos cada opción antes de que gastes un dólar de tus ahorros.",
    "dp.p1d": "Programa estatal de Nevada que cubre el pago inicial y los costos de cierre para compradores calificados.",
    "dp.p2d": "Ayuda para compradores primerizos en condados calificados de Nevada, con tasas competitivas.",
    "dp.p3d": "Por cada dólar que aportas, los fondos del programa multiplican tu poder de pago inicial.",
    "dp.cta": "Verificar Mi Elegibilidad",
    "dp.note": "Los términos cambian — verificamos tu elegibilidad actual en tu cita.",

    "rv.eyebrow": "Historias de Clientes",
    "rv.heading": "786 ventas. Así se sintieron algunas.",

    "tm.eyebrow": "El Equipo",
    "tm.h2": "Los nombres clave en bienes raíces de Las Vegas.",
    "tm.onyRole": "Agente Principal · DV Luxury Realty",
    "tm.aceRole": "Bienes Raíces · Seguros · DV Luxury Realty",
    "tm.sales": "786 ventas en su carrera",
    "tm.naykyRole": "Agente de Bienes Raíces · DV Luxury Realty",

    "cta.eyebrow": "Empieza Aquí",
    "cta.h2a": "Las llaves están más",
    "cta.h2b": "cerca de lo que crees.",
    "cta.body": "Una cita. Revisamos tu crédito, tus programas y tus propiedades — y te vas con un plan escrito para comprar.",
    "cta.button": "Agenda una Cita",

    "ft.tagline": "Casas en Las Vegas, presentadas con claridad y honestidad — con reparación de crédito y ayuda para el pago inicial hasta entregarte las llaves.",
    "ft.contact": "Contacto",
    "ft.explore": "Explorar",
    "ft.currentListings": "Propiedades Actuales",
    "ft.recentlySold": "Vendidas Recientemente",
    "ft.agentPortal": "Portal del Agente",
    "ft.partners": "Nuestros Socios de Confianza",

    "home.nowShowing": "Ahora en Exhibición",
    "home.currentListings": "Propiedades Actuales",
    "home.viewAll": "Ver Toda la Colección",
    "home.recentlySold": "Vendidas Recientemente por The Valdivieso Group",

    "ls.eyebrow": "La Colección",
    "ls.h1": "Propiedades, sin ruido.",
    "ls.sub": "Cada casa que The Valdivieso Group muestra o ha cerrado recientemente — precios claros, fotos reales, un clic para tu visita.",
    "ls.all": "Todas",
    "ls.forSale": "En Venta",
    "ls.sold": "Vendidas",
    "ls.anyBeds": "Recámaras",
    "ls.bedsSuffix": "+ Rec.",
    "ls.anyPrice": "Cualquier Precio",
    "ls.under400": "Menos de $400K",
    "ls.searchPh": "Buscar dirección o código postal…",
    "ls.residences": "Propiedades",
    "ls.residence": "Propiedad",
    "ls.loading": "Cargando…",
    "ls.emptyTitle": "Ninguna propiedad coincide.",
    "ls.emptyBody": "Ajusta un filtro — o llama al",

    "dt.back": "Todas las Propiedades",
    "dt.about": "Sobre Esta Propiedad",
    "dt.listedBy": "Presentada por The Valdivieso Group · DV Luxury Realty · Lic. #S.0200120",
    "dt.perSqft": "/ pie²",
    "dt.beds": "Rec.",
    "dt.baths": "Baños",
    "dt.sqft": "Pies²",
    "dt.schedule": "Agendar una Cita",
    "dt.ask": "Pregúntanos sobre reparación de crédito y ayuda de pago inicial de Nevada para esta casa.",
    "dt.agent": "Agente",
    "dt.notFound": "Esta propiedad ya no está disponible.",
    "dt.backTo": "Volver a la Colección",

    "bk.eyebrow": "Cita Privada",
    "bk.title": "Agenda con The Valdivieso Group",
    "bk.namePh": "Nombre Completo",
    "bk.phonePh": "Teléfono",
    "bk.emailPh": "Correo (opcional)",
    "bk.tour": "Visita a la Propiedad",
    "bk.qualification": "Calificar para Comprar",
    "bk.credit_repair": "Plan de Reparación de Crédito",
    "bk.down_payment": "Ayuda para el Pago Inicial",
    "bk.notesPh": "¿Algo que debamos saber? (opcional)",
    "bk.submit": "Solicitar Cita",
    "bk.sending": "Enviando…",
    "bk.prefer": "¿Prefieres llamar?",
    "bk.success": "Solicitud de cita recibida — te confirmaremos en breve.",
    "bk.error": "No se pudo enviar tu solicitud. Llama al 702-241-4761.",

    marquee: [
      "Las Vegas, Nevada",
      "786 Casas Vendidas",
      "Especialistas en Crédito",
      "Ayuda Para el Pago Inicial",
      "DV Luxury Realty",
      "Se Habla Español",
    ],
  },
};
